import { render, staticRenderFns } from "./commodityCategory.vue?vue&type=template&id=c658c1ac&scoped=true"
import script from "./commodityCategory.vue?vue&type=script&lang=js"
export * from "./commodityCategory.vue?vue&type=script&lang=js"
import style0 from "./commodityCategory.vue?vue&type=style&index=0&id=c658c1ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c658c1ac",
  null
  
)

export default component.exports